import { render, staticRenderFns } from "./allOrders.vue?vue&type=template&id=57b9655a&scoped=true"
import script from "./allOrders.vue?vue&type=script&lang=js"
export * from "./allOrders.vue?vue&type=script&lang=js"
import style0 from "./allOrders.vue?vue&type=style&index=0&id=57b9655a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b9655a",
  null
  
)

export default component.exports